export const FETCH_PRODUCTRETURNDETAILS_INIT_ACTION =
  "FETCH_PRODUCTRETURNDETAILS_INIT_ACTION";
export const FETCH_PRODUCTRETURNDETAILS_SUCCESS_ACTION =
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_PRODUCTRETURNDETAILS_FAIL_ACTION =
  FETCH_PRODUCTRETURNDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_PRODUCTRETURNSEARCH_INIT_ACTION =
  "FETCH_PRODUCTRETURNSEARCH_INIT_ACTION";
export const FETCH_PRODUCTRETURNSEARCH_SUCCESS_ACTION =
  FETCH_PRODUCTRETURNSEARCH_INIT_ACTION + "_SUCCESS";
export const FETCH_PRODUCTRETURNSEARCH_FAIL_ACTION =
  FETCH_PRODUCTRETURNSEARCH_INIT_ACTION + "_ERROR";

export const FETCH_PRODUCTRETURNVIEW_INIT_ACTION =
  "FETCH_PRODUCTRETURNVIEW_INIT_ACTION";
export const FETCH_PRODUCTRETURNVIEW_SUCCESS_ACTION =
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_PRODUCTRETURNVIEW_FAIL_ACTION =
  FETCH_PRODUCTRETURNVIEW_INIT_ACTION + "_ERROR";

export const FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION =
  "FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION";
export const FILTER_BY_PRODUCTRETURN_STATUS_SUCCESS_ACTION =
  FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION + "_SUCCESS";
export const FILTER_BY_PRODUCTRETURN_STATUS_FAIL_ACTION =
  FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION + "_ERROR";

export function ProductReturn() {
  return {
    type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION
  };
}
export function ProductReturnsSlectedPage(value) {
  return {
    type: FETCH_PRODUCTRETURNDETAILS_INIT_ACTION,
    value: value
  };
}
export function ProductReturnsSearch(value) {
  return {
    type: FETCH_PRODUCTRETURNSEARCH_INIT_ACTION,
    value: value
  };
}
export function ProductReturnsSearchSelectedPage(value) {
  return {
    type: FETCH_PRODUCTRETURNSEARCH_INIT_ACTION,
    value: value
  };
}
export function ProductReturnview(value) {
  // console.log("++++++++++++++++++++++++++++++");

  return {
    type: FETCH_PRODUCTRETURNVIEW_INIT_ACTION,
    value: value
  };
}

export function FliterSearchProductUser(value) {
  return {
    type: FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION,
    value: value
  };
}
export function fltrProductUserPagetn(value) {
  return {
    type: FILTER_BY_PRODUCTRETURN_STATUS_INIT_ACTION,
    value: value
  };
}
